import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../theme';

const row = {
  display: 'flex',
  alignItems: 'center',
  padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
};

export const useTablesStyles = createStyles(() => ({
  simpleTableHead: row,
  simpleTableRow: row,
  simpleTableCell: {
    padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
    minWidth: 0,
  },
}));
